import Device from './../../devices/device';
import * as playerConstants from "../../utils/playerConstants";
import PlayerUtil from './../../devices/all/PlayerUtil';
import RequestManager from '../../requests/RequestManager';
import ManifestTask from '../../utils/webinitiator/requests/ManifestTask';
import { AdsUtils } from '../../AAF/Ads/Utils';
import CertificateTask from '../../requests/tasks/video/CertificateTask';

class Web0sPlayerUtil extends PlayerUtil {

    constructor() {
      super();
      /**
       * Where to parse manifest xml, device or middleware
       *
       * OVERWRITE class father value (see father's default value, only apply to sony, huawei and webos (some providers))
       */
      this.parseManifestOnDevice = true;
    }

    getSDKVersion(__callback) {
      const ID = Device.getDevice().getId();
      const receiveSDKVersion = sdkVersion => {
        __callback(sdkVersion);
      };

      ID.getTVSDKVersion(receiveSDKVersion);
    }

    resolveStreamType(encodes, provider, isLive) {

        if(isLive) {
            return playerConstants.HLS_KR;
        }

        if(encodes === null || encodes.length < 1) {
            return null;
        }

        // All devices except nagra can play *SS single* and SS_MA so this is the prefered streamType of the app (TODO, is it safe?)
        let preferedStreamType = playerConstants.SS;
        let preferedStreamType_ma = playerConstants.SS_MA;

        let streamType = null;


        let i;
        // First priority: test if we can play prefered streamType with MA
        let ifstreamType_ma = this.ifMultipleAudio(preferedStreamType, false);
        if(ifstreamType_ma) {
            // TODO change to find/filter ES6 syntax
            for(i = 0; i < encodes.length; i++) {
                if(preferedStreamType_ma === encodes[i]) {
                    streamType = preferedStreamType_ma; // We found a stream type multipleaudio, we play it
                }
            }
        }
        // Second priority: single, if content dont have multiple audio, search for the prefered single
        if(!streamType) {
            // TODO change to find/filter ES6 syntax
            for(i = 0; i < encodes.length; i++) {
                if(preferedStreamType === encodes[i]) {
                    streamType = encodes[i]; // We found a stream type multipleaudio, we play it
                }
            }
        }
        // Third priority: if content dont have the pefered in single, search for another single device supports
        if(!streamType) {
          let device_config = Device.getDevice().getConfig();
            let supported_stream_types_vod = device_config.supported_stream_types.vod;
            let j;
            // TODO change to find/filter ES6 syntax
            for(i = 0; i < device_config.supported_stream_types.vod.length; i++) {
                // skip prefered stream type, we check this one above (single and multiple and wasnt founded)
                if(supported_stream_types_vod[i] === preferedStreamType) {
                    continue;
                }
                // TODO change to find/filter ES6 syntax
                for(j = 0; j < encodes.length; j++) {
                    if(encodes[j] === supported_stream_types_vod[i]) {
                        // First we found
                        streamType = encodes[j];
                        break;
                    }
                }
            }
        }


        return streamType;
    }

    async getCertificate(url, header = null) {
        try {
            const certificateTask = new CertificateTask(url, null, (header ? true : false), header);
            let certificateResult = await RequestManager.addRequest(certificateTask);
            let cert = new Uint8Array(certificateResult);
            return cert;
        } catch (error) {
            console.log("[getCertificate]", error);
        }
    }

    async replaceSourceMedia(pgm, streamType, provider = null, providerCode = null, isLive = false, streamContentType = '') {

      const useBitmovinPlayer = AdsUtils.activeBitmovinPlayer();

        console.log('[BITMOVIN] PlayerUtils WebOS useBitmovinPlayer: ', useBitmovinPlayer, streamContentType);
        switch (streamType) {
            case playerConstants.SS:
            case playerConstants.SS_MA:
                if (useBitmovinPlayer) {
                    if (pgm.media.video_url) pgm.media.video_url = pgm.media.video_url.replace('http:', 'https:');
                    if (pgm.media.server_url) pgm.media.server_url = pgm.media.server_url.replace('http:', 'https:');
                }
                break;
            case playerConstants.DASHPR:
            case playerConstants.DASHPR_MA:
                break;
            case playerConstants.DASHWV:
            case playerConstants.DASHWV_MA:
                if (useBitmovinPlayer) {
                    if (providerCode && providerCode != playerConstants.PROVIDER_CODE_HBO) {
                        if(pgm.media.certificate_url) pgm.media.resultCert = await this.getCertificate(pgm.media.certificate_url);
                    }
                }
                break;
            default:
                break;
        }

        return pgm;
    }
}

export default Web0sPlayerUtil;



// WEBPACK FOOTER //
// ./src/devices/web0s/PlayerUtil.js